import styled from 'styled-components';
import { useSelector } from 'react-redux';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import imageHelper from '@utils/imageHelper';
import { Spacings, BgColors, Fonts, mobile } from '../../../../styleConstants';
import SectionTitle from '../SectionTitle';
import SectionDescription from '../SectionDescription';
import ContentContainer from '../ContentContainer';
import ShareContainer from '../ShareContainer/ShareContainer';

const Wrapper = styled.section`
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  border-radius: ${Spacings.SPACING_2B};
  background-color: ${BgColors.WHITE};
  padding: ${Spacings.SPACING_6B};
  display: grid;
  grid-template: 1fr / max-content 1fr;
  grid-column-gap: 38px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    display: block;
    padding: ${Spacings.SPACING_0B};
    margin-top: 120px;
  }
`;

const InfoContainer = styled.div`
  padding: ${Spacings.SPACING_14B};
  @media only screen and (max-width: ${mobile.maxWidth}) {
    padding: ${Spacings.SPACING_6B};
    text-align: center;
  }
`;

const StyledTitle = styled(SectionTitle)`
  font-size: 40px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: ${Fonts.H3};
    line-height: 30px;
  }
`;

const StyledDescription = styled(SectionDescription)`
  margin-top: ${Spacings.SPACING_4B};
  @media only screen and (max-width: ${mobile.maxWidth}) {
    font-size: ${Fonts.H5};
  }
`;

const ShareVideo = styled.video`
  width: 470px;
  @media only screen and (max-width: 1400px) {
    width: 400px;
  }
  @media only screen and (max-width: ${mobile.maxWidth}) {
    width: 100%;
  }
`;

const SummitShare = () => {
  const staticTexts = useSelector(({ summit }) => summit.staticTexts);
  return (
    <ContentContainer as={Wrapper}>
      <ShareVideo loop autoPlay playsInline muted>
        <source
          src={imageHelper.getImage('prodigy/invite-friends.mp4')}
          type="video/mp4"
        />
      </ShareVideo>
      <InfoContainer>
        <StyledTitle>{staticTexts.shareHeader || ''}</StyledTitle>
        <StyledDescription $size={Fonts.H4}>
          {staticTexts.shareDesc || ''}
        </StyledDescription>
        <ShareContainer />
      </InfoContainer>
    </ContentContainer>
  );
};

export default SummitShare;
